import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'

import {fetchNationalRegistry} from '../national-registry/actions'

export const customerTypes = createTypes([
    'REQUEST',
    'RECEIVE',
    'ERROR',
    'SUCCESS',
    'ADD_EMPTY',
    'ADD_TO_PPL_BY_KT',
    'REQUEST_UPDATE',
    'RECEIVE_UPDATE',
    'ERROR_UPDATE',
    'REQUEST_PAYER',
    'RECEIVE_PAYER',
    'ADD_EMPTY_PAYER',
    'ADD_TO_PPL_BY_KT_PAYER',
    'ERROR_PAYER',
], 'CUSTOMERS');


export const requestCustomer = () => {
    return {
        type: customerTypes.REQUEST,
    };
};

export const receiveCustomer = (response, query={}) => {
    return {
        type: customerTypes.RECEIVE,
        query: query,
        data: response,
    };
};

export const doAddEmptyCustomer = (person) => {
    return {
        type: customerTypes.ADD_EMPTY,
        person: person,
    };
};

export const addEmptyCustomer = (person) => {
    return dispatch => {
        dispatch(fetchCustomer(person.OrgId, person.Name))
    }
};

export const receiveCustomerError = (response) => {
    return {
        type: customerTypes.ERROR,
        error: response,
    };
};

export const addOnlyToPeopleByKennitala = (data) => {
    return {
        type: customerTypes.ADD_TO_PPL_BY_KT,
        data: data,
    }
}

export const _fetchCustomer = (customerId, name=null, lookup='regular', contractType=null) => {
    return dispatch => {

        let success = true

        let apiUrl = "/api/v1/customers/"
        switch(lookup) {

            case 'mypages':
                apiUrl = "/api/v1/mypagescontracts/"
                break;
        }
        apiUrl = (customerId === undefined) ? apiUrl : apiUrl+`${customerId}/`;
        apiUrl = !contractType ? apiUrl : apiUrl + `?contractType=${contractType}`;

        dispatch(requestCustomer());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCustomer(response, customerId));
            } else {
                dispatch(receiveCustomerError(response))
                if(name !== null) {
                    dispatch(doAddEmptyCustomer({OrgId: customerId, Name: name}))
                }
            }
            dispatch(fetchNationalRegistry(customerId))
        })
        .catch(handleNetworkError);
    };
};




export const requestCustomerPayer = () => {
    return {
        type: customerTypes.REQUEST_PAYER,
    };
};

export const receiveCustomerPayer = (response) => {
    return {
        type: customerTypes.RECEIVE_PAYER,
        data: response,
    };
};

export const doAddEmptyCustomerPayer = (person) => {
    return {
        type: customerTypes.ADD_EMPTY_PAYER,
        person: person,
    };
};

export const addEmptyCustomerPayer = (person) => {
    return dispatch => {
        dispatch(fetchCustomerPayer(person.OrgId, person.Name))
    }
};

export const receiveCustomerPayerError = (response) => {
    return {
        type: customerTypes.ERROR_PAYER,
        error: response,
    };
};


export const _fetchCustomerPayer = (customerId, name=null) => {
    return dispatch => {

        let success = true

        let apiUrl = "/api/v1/mypagespayercontracts/"

        dispatch(requestCustomerPayer());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch((customerId === undefined) ? apiUrl : apiUrl+`${customerId}/`, {
            headers: headers,
            credentials: 'include',
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCustomerPayer(response, customerId));
            } else {
                dispatch(receiveCustomerPayerError(response))
                if(name !== null) {
                    dispatch(doAddEmptyCustomerPayer({OrgId: customerId, Name: name}))
                }
            }
            dispatch(fetchNationalRegistry(customerId))
        })
        .catch(handleNetworkError);
    };
};








export const fetchCustomer = (customerId, name=null) => {
    return _fetchCustomer(customerId, name)
}

export const fetchCustomerMyPages = (customerId, name=null) => {
    return _fetchCustomer(customerId, name, 'mypages')
}

export const fetchCustomerPayer = (customerId, name=null) => {
    return _fetchCustomerPayer(customerId, name)
}

export const fetchCustomerFilterByContractType = (customerId, name=null, contractType=null) => {
    return _fetchCustomer(customerId, name, 'regular', contractType);
}


export const requestCustomerUpdate = () => {
    return {
        type: customerTypes.REQUEST_UPDATE,
    };
};

export const receiveCustomerUpdate = (response, query={}) => {
    return {
        type: customerTypes.RECEIVE_UPDATE,
        query: query,
        data: response,
    };
};

export const receiveCustomerUpdateError = (response) => {
    return {
        type: customerTypes.ERROR_UPDATE,
        error: response,
    };
};



export const updateCustomer = (customerId, data={}) => {
    return dispatch => {

        let success = true

        let apiUrl = `/api/v1/customers/${customerId}/update/`

        dispatch(requestCustomerUpdate());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCustomerUpdate(response, customerId));
            } else {
                dispatch(receiveCustomerUpdateError(response))
            }
        })
        .catch(handleNetworkError);
    };
};